import { useQuery } from "@tanstack/react-query";

import { PageProjectRead, ProjectListRequest, ProjectRead, getRanaApiV1 } from "@nens/rana/api-v1";

const PROJECT_PAGE_SIZE = 100;

type ProjectListPageFetcher = (
  request: Pick<ProjectListRequest, "limit" | "offset">
) => Promise<PageProjectRead>;

export async function fetchAllProjectPages(
  projectList: ProjectListPageFetcher
): Promise<ProjectRead[]> {
  const projects: ProjectRead[] = [];
  let offset = 0;

  while (true) {
    const page = await projectList({ limit: PROJECT_PAGE_SIZE, offset });
    projects.push(...page.items);

    if (page.items.length === 0 || projects.length >= page.total) break;
    offset += page.items.length;
  }

  return projects;
}

export function sortProjects(projects: ProjectRead[]): ProjectRead[] {
  return [...projects].sort((projectA, projectB) => {
    return projectA.name.localeCompare(projectB.name);
  });
}

const getRanaProjectListQuery = () => {
  const ranaApi = getRanaApiV1();

  return ranaApi.getQueryOptions({
    queryKey: ["projects", "list"],
    queryFn: async () => ({
      items: sortProjects(await fetchAllProjectPages(ranaApi.ProjectsApi.projectList)),
    }),
  });
};

export const useRanaProjectListQuery = () => useQuery(getRanaProjectListQuery());
